﻿export class request {
    public api_key: string = "";
}